"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const cardResources_1 = require("../common/cardResources");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardResourceCounter',
    props: {
        amount: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        cssClass() {
            return cardResources_1.cardResourceCSS[this.type];
        },
    },
});
